import React, { Component } from "react";
import { Navigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import Serverurl from './Apiurl';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import signingBgImg from './images/signingbg.jpg'; 

export default class BusinessSignup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      businessName: '',
      email: '',
      phoneNo: '',
      password: '',
      errormessage: '',
      open: false,
      redirect: false,
      pagename: '',
      showPassword: false,
	    otp: '',
  bu_id: '',
showOtp: false,
signupSuccess: false,
    };
  }

  componentDidMount() {}

  myChangeHandler = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({ [name]: value });
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };
  
  
  componentDidMount() {
document.body.style.backgroundImage = `url(${signingBgImg})`;
  document.body.style.backgroundSize = 'cover';
  document.body.style.backgroundPosition = 'center';
  document.body.style.backgroundRepeat = 'no-repeat';

	if(localStorage.getItem("GBuserid")!==null)
	{
		this.setState({
							
							
						  }) 
	}else{
		
		this.setState({
							Username: localStorage.getItem("GBUsername"),
							Password: localStorage.getItem("GBpwd"),
						  }) 
		}
		
	

}
componentWillUnmount() {
  // Remove background image from body when leaving this page
  document.body.style.backgroundImage = '';
  document.body.style.backgroundSize = '';
  document.body.style.backgroundPosition = '';
  document.body.style.backgroundRepeat = '';
  document.body.style.backgroundAttachment = '';
}
  
  
  
  
  
  

  handleSignup = (event) => {

event.preventDefault();

let {
 businessName,
 email,
 phoneNo,
 password
} = this.state;


if(businessName === '')
{
 this.setState({
  errormessage:"Enter Business Name",
  open:true
 });
 return;
}


if(email === '')
{
 this.setState({
  errormessage:"Enter Email",
  open:true
 });
 return;
}


if(phoneNo === '')
{
 this.setState({
  errormessage:"Enter Phone Number",
  open:true
 });
 return;
}


if(password === '')
{
 this.setState({
  errormessage:"Enter Password",
  open:true
 });
 return;
}



let formData = new FormData();

formData.append('action','businesssignup');
formData.append('bu_businessname',businessName);
formData.append('bu_phoneno',phoneNo);
formData.append('bu_emailid',email);
formData.append('bu_password',password);
formData.append("userid",localStorage.getItem("GBuserid") || 0);

axios
  .post(Serverurl + "ajaxbusiness.php", formData)
  .then((res) => {
    const result = String(res.data).trim();

    console.log("SIGNUP RESPONSE:", result);

    if (result === "EXISTS") {
      this.setState({
        errormessage: "Email already exists",
        open: true,
        showOtp: false,
      });

      return;
    }

    const response = result.split("~");

    if (!response[1]) {
      this.setState({
        errormessage: "Signup failed. Please try again.",
        open: true,
        showOtp: false,
      });

      return;
    }

    this.setState({
      bu_id: response[1],
      showOtp: true,
      errormessage: "",
      open: false,
    });
  })
  .catch((error) => {
    console.error(error);

    this.setState({
      errormessage: "Something went wrong. Please try again.",
      open: true,
      showOtp: false,
    });
  });
};

handleVerifyOtp = () => {

  let formData = new FormData();

  formData.append('action', 'businesssignupverify');
  formData.append('bu_id', this.state.bu_id);
  formData.append('otp', this.state.otp);

  axios.post(Serverurl + "ajaxbusiness.php", formData)
    .then(res => {

      if (res.data[0].status === "SUCCESS") {

        this.setState({
          signupSuccess: true,
          showOtp: false,
          errormessage: "",
          open: false
        });

      } else {

        this.setState({
          errormessage: "Invalid OTP",
          open: true
        });

      }

    })
    .catch(error => {

      console.error(error);

      this.setState({
        errormessage: "Something went wrong. Please try again.",
        open: true
      });

    });
};

  handleErrorclose = () => {
    this.setState({ open: false });
  };

  render() {
   if (this.state.redirect) {
  return (
    <Navigate 
      to={this.state.pagename} 
      state={{
        bu_businessname: this.state.businessName,
        bu_emailid: this.state.email,
        bu_phoneno: this.state.phoneNo
      }} 
    />
  );
}

if (this.state.signupSuccess) {

    return (
      <div
        className="loginmain"
        style={{
          backgroundImage: `url(${signingBgImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: '100vh',
          width: '100%'
        }}
      >

        <div className="main">

          <div className="Logindiv">

            <h1>Signup Successful</h1>

            <Alert
              severity="success"
              sx={{ mb: 2 }}
            >
              Your signup is successful. Please click below to login.
            </Alert>

            <div className="loginbtn">

              <Button
                variant="contained"
                className="primartybtn"
                onClick={() => {
                  this.setState({
                    redirect: true,
                    pagename: '/Businesslogin'
                  });
                }}
                style={{
                  borderRadius: "20px",
                  minWidth: "110px"
                }}
              >
                Login
              </Button>

            </div>

          </div>

        </div>

      </div>
    );
  }



if(this.state.showOtp)
{

return(

<div className="loginmain"
style={{
    backgroundImage: `url(${signingBgImg})`,
    backgroundSize: 'cover',
  
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    width: '100%'
  }}>

<div className="main">

<div className="Logindiv"
>


<h1>Verify OTP</h1>


  {this.state.open && (
        <Alert
          severity="error"
          sx={{ mb: 2 }}
          action={
            <IconButton
              size="small"
              onClick={this.handleErrorclose}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {this.state.errormessage}
        </Alert>
      )}

     <TextField 
  fullWidth 
  placeholder="Enter OTP" 
  value={this.state.otp} 
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "");

    this.setState({
      otp: value
    });
  }}
  inputProps={{
    inputMode: "numeric",
    pattern: "[0-9]*"
  }}
/>
<p className="aligncenter">
<div className="verifybtn">
<Button
    className="primartybtn"
    variant="contained"
    onClick={this.handleVerifyOtp}
>
    Verify OTP
</Button>
</div>
</p>
</div>

</div>

</div>


);

}
    return (
      <div className="loginmain">
        <div className="main">
          <div className="Logindiv">
            <h1>Sign Up</h1>

            <Collapse in={this.state.open}>
              <Alert
                severity="error"
                action={
                  <IconButton size="small" onClick={this.handleErrorclose}>
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                {this.state.errormessage}
              </Alert>
            </Collapse>

            <p>
              <TextField
                fullWidth
                name="businessName"
                value={this.state.businessName}
                onChange={this.myChangeHandler}
                placeholder="Business Name"
				slotProps={{
                htmlInput: { maxLength: 150, tabIndex: 1 }
              }}
              />
            </p>

            <p>
              <TextField
                fullWidth
                name="email"
                value={this.state.email}
                onChange={this.myChangeHandler}
                placeholder="Email"
				slotProps={{
                htmlInput: { maxLength: 150, tabIndex: 2 }
              }}
              />
            </p>

            <p>
              <TextField
                fullWidth
                name="phoneNo"
                value={this.state.phoneNo}
                onChange={this.myChangeHandler}
                placeholder="Phone Number"
				slotProps={{
                htmlInput: { maxLength: 10, tabIndex: 3 }
              }}
              />
            </p>

            <p>
              <TextField
                fullWidth
                name="password"
                type={this.state.showPassword ? 'text' : 'password'}
                value={this.state.password}
                onChange={this.myChangeHandler}
                placeholder="Password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={this.handleClickShowPassword}
                        edge="end"
                      >
                        {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </p>

            <div className="loginbtn">
              <Button variant="contained" className="primartybtn"
 style={{ borderRadius: "20px",
    minWidth: "110px", }}
	onClick={this.handleSignup}>
                Sign Up
              </Button>
              
            </div>
			<p className="signup">Already have account? <a href="/Businesslogin">Login</a></p>
          </div>
        </div>
      </div>
    );
  }
}